import { Component, OnInit, Input, ViewChild, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { IMyDpOptions } from 'mydatepicker';
import { DateService } from 'src/app/date.service';
import { clientonboardBO } from '../client-onboarding.model';
import { SignaturePad } from 'angular2-signaturepad';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { clientOnboardingService } from '../client-onboarding.service';
import { Subject } from 'rxjs';
import { DatePipe, ViewportScroller } from '@angular/common';
import { GlobalComponent } from 'src/app/global/global.component';
import { takeUntil } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { CommonHttpService } from 'src/app/common.service';
import { GeneralService } from 'src/app/service/general.service';
import { Additional_AppointeeAddressDocumentBO, Application_Employer_Identification_NumberDocumentBO, ClientAgreementDocumentBO, ClientAgreementDocumentMergedBO, CompleteBo, EmployerOrPayerAppointmentOfAgentDocumentBO, Individual_Sole_Proprietor_OfAttornyDocumentBO, ParticipantAgreementDocumentBO, Release_of_InformationDocumentBO, SendToUserBO, SubmitClientAggremntBo } from './files.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfigurationService } from 'src/app/configuration.service';

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss']
})

export class FilesComponent implements OnInit {
  @Input() clientonboardBO = new clientonboardBO();
  private onDestroy$: Subject<void> = new Subject<void>();
  ClientAgreementDocumentMergedBO = new ClientAgreementDocumentMergedBO()
  ClientAgreementDocumentBO = new ClientAgreementDocumentBO();
  public EmployerIdentificationForm: FormGroup
  public EmployerORPayerForm: FormGroup
  public IndivualForm: FormGroup;
  stateList: any = [];
  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };

  @ViewChild('grid') public grid: GridComponent;
  @ViewChild("EnrollmentsignaturePad") EnrollmentsignaturePad: SignaturePad;
  @ViewChild("EnrollPad") EnrollPad: SignaturePad;
  @ViewChild("Enroll") Enroll: SignaturePad;
  @ViewChild('YoursignaturePad') YoursignaturePad: SignaturePad;
  @ViewChild('AuthorizesignaturePad') AuthorizesignaturePad: SignaturePad;
  @ViewChild("signpadone") signpadone: SignaturePad;
  @ViewChild("signpadtwo") signpadtwo: SignaturePad;
  @ViewChild("userpad") userpad: SignaturePad;
  @ViewChild("Appointeepad") Appointeepad: SignaturePad;
  @ViewChild("Taxpayerpad") Taxpayerpad: SignaturePad;
  @ViewChild("Spousepad") Spousepad: SignaturePad;
  @ViewChild("Participantpad") Participantpad: SignaturePad;
  @ViewChild("pantpad") pantpad: SignaturePad;
  @ViewChild("pantpad1") pantpad1: SignaturePad;
  @ViewChild("powerpad") powerpad: SignaturePad;

  @Output() saveAllEvent: EventEmitter<any> = new EventEmitter<any>();

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };

  portallist1: any;
  portallist2: any;
  portallist3: any;
  portallist4: any;
  portallist5: any;
  portallist6: any;

  ssnbool1: boolean = false;
  ssnbool2: boolean = false;
  ssnbool3: boolean = false;
  ssnbool4: boolean = false;
  ssnbool5: boolean = false;
  ssnbool6: boolean = false;
  ssnbool7: boolean = false;
  ssnbool8: boolean = false;
  
  snbool1: boolean = false;
  snbool2: boolean = false;
  snbool3: boolean = false;
  snbool4: boolean = false;
  snbool5: boolean = false;
  snbool6: boolean = false;
  snbool7: boolean = false;
  snbool8: boolean = false;
  isSaveorUpdateBoolean:boolean = false;
  phonerr: string[] = []
  phonerr1: string[] = []
  phonerr2: string[] = []
  ziperr: string[] = []
  errphone: boolean[] = []
  errphone1: boolean[] = []
  errphone2: boolean[] = []
  errZip: boolean[] = []

  bool1: boolean = false;
  bool2: boolean = false;
  bool3: boolean = false;
  bool4: boolean = false;

  pantsign: string = ''
  pantsign1: string = ''
  Partisign: string = ''  
  signature: string = ''
  signhere1: string = ''
  signhere2: string = ''
  SendToClientNotes: string
  sendToClientBO: SendToUserBO = new SendToUserBO()

  public signaturePadOptions: Object = {
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 200,
    'maxWidth': 5,
    'penColor': "blue"
  };

  constructor(public clientservice: clientOnboardingService, public configurationservice:ConfigurationService  ,public ngxService: NgxUiLoaderService, private scroller: ViewportScroller, private fb: FormBuilder, private afterChangedError: ChangeDetectorRef, public commonhttp: CommonHttpService, public general: GeneralService, public toastrService: ToastrService, private http: HttpClient, public global: GlobalComponent, public datepipe: DatePipe, public dateservice: DateService, private formbuilber: FormBuilder, public toastr: ToastrService) {

    ////////////////// EmployerIdentificationForm //////////////////////////////
    this.EmployerIdentificationForm = this.fb.group({
      Designetele: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Designefax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      applitele: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      applifax: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Identificationssn: ["", [Validators.minLength(9), Validators.maxLength(9)]],
    })

    ////////////////////////// EmployerORPayerForm ///////////////////////////////////////
    this.EmployerORPayerForm = this.fb.group({
      Payerzip1: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      Payerphone1: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      Payerzip2: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      Payerphone2: ["", [Validators.minLength(14), Validators.maxLength(14)]],
    })

    ////////////////////////// IndivualForm ///////////////////////////////////////////////////
    this.IndivualForm = this.fb.group({
      phone1: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax1: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      phone2: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax2: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      fax3: [""],
      phone3: ["", [Validators.minLength(14), Validators.maxLength(14)]],
      phone4: [""],
      zip1: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      zip2: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      zip3: ["", [Validators.minLength(5), Validators.maxLength(11)]],
      zip4: [""],
      ssn1: ["", [Validators.minLength(9), Validators.maxLength(9)]],
      ssn2: ["", [Validators.minLength(9), Validators.maxLength(9)]],
      Minnesota: [""]
    })

  }


  ngOnInit(): void {
    console.log(this.clientonboardBO,"clientonboardBO----")
    let goal1 = new Additional_AppointeeAddressDocumentBO();
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress.push(goal1);
     
    if (this.clientonboardBO.documentid != null && this.clientonboardBO.documentid != undefined && this.clientonboardBO.documentid != "00000000-0000-0000-0000-000000000000") {
      this.GetDocumentData('new');
    }
    if (this.clientonboardBO.documentid == "00000000-0000-0000-0000-000000000000" && this.clientonboardBO.templateid != "00000000-0000-0000-0000-000000000000") {
      this.GetClientTemplateDetails();
      this.getClientDetails();
    }

    this.GetYesNo();
    this.getself();    
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });

    if (this.clientonboardBO?.datalist?.onboardStatusLidName == 'SUBMITTED' || this.clientonboardBO?.datalist?.onboardStatusLidName == 'ACCEPTED' || this.clientonboardBO?.datalist?.onboardStatusLidName == 'REJECTED' || this.clientonboardBO?.isCompleted) {
      this.EmployerIdentificationForm.disable();
      this.EmployerORPayerForm.disable();
      this.IndivualForm.disable();
      // this.IndivualForm
    }

  }

  ///////////////// GETCLIENT DETAILS///////////////////
  getClientDetails() {  
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Clientid", this.clientonboardBO.clientID);
      this.clientservice.GetClientDetailsAgency(params).subscribe((data: any) => {
        this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.clientName = data.fullName != null ? data.fullName : null;
        this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.participantName = data.fullName != null ? data.fullName : null;
        this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyName = this.global.agencyName;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersOrPayerName = data.fullName != null ? data.fullName : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.suiteOrRoomNumber = data.street != null ? data.street : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.city = data.city != null ? data.city : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.state = data.state != null ? data.state : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.zip = data.zipCode != null ? data.zipCode : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.street_Addres_or_PoBox = data.street != null ? data.street : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.apt_or_Suit = data.street != null ? data.street : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber = data.phone1 != null ? data.phone1 : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.city = data.city != null ? data.city : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.state = data.state != null ? data.state : null;

        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.zipCode = data.zipCode != null ? data.zipCode : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.emailAddress = data.email != null ? data.email : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.taxpayerName = data.fullName != null ? data.fullName : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber = data.phone1 != null ? data.phone1 : this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber ;
        this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyName = data.agencyName;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agenctsName = data.agencyName;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSuiteOrRoomNumber = data.agencyStreet != null ? data.agencyStreet : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity = data.agencyCity != null ? data.agencyCity : '';
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState = data.agencyState != null ? data.agencyState : '';
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip = data.agencyZipCode != null ? data.agencyZipCode : '';
        this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyMailingAddress = data.agencyStreet != null ? data.agencyStreet : null;
        this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zip = 
        (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity != null && 
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity != undefined &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity != "" &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState != null && 
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState != undefined &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState != "" &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip != null &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip != undefined && 
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip != ""
        ) ? this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity + ',' + this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState + ',' + this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip :
         this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zip
      })
    }
    else {
      this.clientservice.GetClientDetailsportal().subscribe((data: any) => {
        this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.clientName = data.fullName != null ? data.fullName : null;
        this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.participantName = data.fullName != null ? data.fullName : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.employersOrPayerName = data.fullName != null ? data.fullName : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.suiteOrRoomNumber = data.street != null ? data.street : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.city = data.city != null ? data.city : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.state = data.state != null ? data.state : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.zip = data.zipCode != null ? data.zipCode : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.street_Addres_or_PoBox = data.street != null ? data.street : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.apt_or_Suit = data.street != null ? data.street : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber = data.phone1 != null ? data.phone1 : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.city = data.city != null ? data.city : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.state = data.state != null ? data.state : null;

        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.zipCode = data.zipCode != null ? data.zipCode : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.emailAddress = data.email != null ? data.email : null;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.taxpayerName = data.fullName != null ? data.fullName : null;
        this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyName = data.agencyName;
        this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber = data.phone1 != null ? data.phone1 : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agenctsName = data.agencyName;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSuiteOrRoomNumber = data.agencyStreet != null ? data.agencyStreet : null;
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity = data.agencyCity != null ? data.agencyCity : '';
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState = data.agencyState != null ? data.agencyState : '';
        this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip = data.agencyZipCode != null ? data.agencyZipCode : '';
        this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyMailingAddress = data.agencyStreet != null ? data.agencyStreet : null;
        this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zip = 
        (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity != null && 
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity != undefined &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity != "" &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState != null && 
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState != undefined &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState != "" &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip != null &&
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip != undefined && 
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip != ""
        ) ? this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity + ',' + this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState + ',' + this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip :
         this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyCity_state_zip
      })
    }
  }

 /////////////////////////////// GET TEMPLATE DETAILS /////////////////////////
  GetClientTemplateDetails() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("TemplateId", this.clientonboardBO.templateid);
      if (this.clientonboardBO.templateid != null && this.clientonboardBO.templateid != undefined) {
        this.clientservice.GetAgencyClientTemplateDetails(params).subscribe((data: any) => {
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO = data.participantAgreementTemplateBO

          this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO = data.release_of_InformationTemplateBO

          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO = data.application_Employer_Identification_NumberTemplateBO
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO = data.individual_Sole_Proprietor_OfAttornyTemplateBO
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress = data.individual_Sole_Proprietor_OfAttornyTemplateBO.additional_appointeeAddress


          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO = data.employerOrPayerAppointmentOfAgentTemplateBO

          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.agencyName = this.global.agencyName;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agenctsName = this.global.agencyName;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSuiteOrRoomNumber = data.agencyStreet != null ? data.agencyStreet : null;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentCity = data.agencyCity != null ? data.agencyCity : null;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentState = data.agencyState != null ? data.agencyState : null;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentZip = data.agencyZipCode != null ? data.agencyZipCode : null;
          this.getClientDetails();
        })
      }

    }
  }


  ////////////////////////////////////// Lov Dropdown ///////////////////////////////////////////
  public YesNoList = []
  GetYesNo() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      let params = new URLSearchParams();
      params.append("Code", "YESORNO");
      this.clientservice.gettype(params).subscribe((data: any) => {
        this.YesNoList = data;
      })
    }
  }

  public selflist = []
  getself() {
      let params = new URLSearchParams();
      params.append("listCode", "ApplicantTitle");
      this.clientservice.gettype(params).subscribe((data: any) => {
        this.selflist = data;
      })
  }
  ///////////////////////////////////////////////// DATE CHANGE FUNCTION ///////////////////////////////////

  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == 'date') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date = val1;
        }
      }
      if (name == 'effdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate = val1;
        }
      }
      if (name == 'exdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date = val1;
        }
      }
      if (name == 'exdate1') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate = val1;
        }
      }
      if (name == 'date1') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate = val1;
        }
      }
      if (name == 'appdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date = val1;
        }
      }
      if (name == 'payerdate1') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = val1;
        }
      }
      if (name == 'payerdate2') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = val1;
        }
      }
      if (name == 'business') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = val1;
        }
      }

      if (name == 'alien') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid = val1;
        }
      }
    }
    if (type == "datechanged") {

      if (name == 'date') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date = val1;
        }
      }
      if (name == 'effdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate = val1;
        }
      }
      if (name == 'exdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date = val1;
        }
      }
      if (name == 'exdate1') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate = val1;
        }
      }
      if (name == 'date1') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate = val1;
        }

      }
      if (name == 'appdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date = val1;
        }
      }
      if (name == 'payerdate1') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = val1;
        }
      }
      if (name == 'payerdate2') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = val1;
        }
      }
      if (name == 'business') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = val1;
        }
      }

      if (name == 'alien') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid = val1;
        }
      }

    }

  }
  /////////////////////////// Get CLIENT DocumentData/////////////////////

  GetDocumentData(val) {

    let params = new URLSearchParams();
    params.append("documentLid", this.clientonboardBO.documentid);

    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {
      this.ClientAgreementDocumentBO.id = this.clientonboardBO.datalist.id;
      this.clientservice.GetClientDocumentForAgency(params).subscribe((data: any) => {
        if (data) {
          this.ClientAgreementDocumentMergedBO = data
          this.ClientAgreementDocumentBO.id= this.ClientAgreementDocumentMergedBO?.id;
          //////////////////////////////////////// TRANSFORM  DATE FORMAT To Get /////////////////////////////////////////
          this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != null && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != undefined) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != undefined && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != undefined && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != undefined && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != undefined && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate, "MM/dd/yyyy") : null;
          this.signhere2 = this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSign;
          this.signhere1 = this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.sign;
          this.pantsign1 = this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.sign;
          this.pantsign = this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2;
          this.Partisign = this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signature;
          this.signature = this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.signature;
          this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare =  this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare?.toString() 
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc =  this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc?.toString()
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates =this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates?.toString();
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein?.toString()
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress = data.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress;
        // if(val =="new") {
        //   this.getClientDetails();
        // }
        }
      },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, "error");
        }
      )
    }
    else {
      this.ClientAgreementDocumentBO.id = this.clientonboardBO.documentid;
      this.ClientAgreementDocumentBO.clientId = this.clientonboardBO.clientID
      this.clientservice.GetClientDocumentForPortal(params).subscribe((data: any) => {
        if (data) {
          this.portallist1 = JSON.parse(JSON.stringify(data.participantAgreementDocumentBO != undefined && data.participantAgreementDocumentBO != null ? data.participantAgreementDocumentBO : ''))
          this.portallist2 = JSON.parse(JSON.stringify(data.release_of_InformationDocumentBO != undefined && data.release_of_InformationDocumentBO != null ? data.release_of_InformationDocumentBO : ''))
          this.portallist3 = JSON.parse(JSON.stringify(data.application_Employer_Identification_NumberDocumentBO != undefined && data.application_Employer_Identification_NumberDocumentBO != null ? data.application_Employer_Identification_NumberDocumentBO : ''))
          this.portallist4 = JSON.parse(JSON.stringify(data.employerOrPayerAppointmentOfAgentDocumentBO != undefined && data.employerOrPayerAppointmentOfAgentDocumentBO != null ? data.employerOrPayerAppointmentOfAgentDocumentBO : ''))
          this.portallist5 = JSON.parse(JSON.stringify(data.individual_Sole_Proprietor_OfAttornyDocumentBO != null && data.individual_Sole_Proprietor_OfAttornyDocumentBO != undefined ? data.individual_Sole_Proprietor_OfAttornyDocumentBO : ''))
          this.portallist6 = JSON.parse(JSON.stringify(this.portallist5.additional_appointeeAddress))
          this.ClientAgreementDocumentMergedBO = data
          //////////////////////////////////////// TRANSFORM  DATE FORMAT To Get /////////////////////////////////////////
          this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != null && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != undefined) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != undefined && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != undefined && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != undefined && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate, "MM/dd/yyyy") : null;
          this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != undefined && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate, "MM/dd/yyyy") : null;
          this.signhere2 = this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSign;
          this.signhere1 = this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.sign;
          this.pantsign1 = this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.sign;
          this.pantsign = this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2;
          this.Partisign = this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signature;
          this.signature = this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.signature;
          this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare =  this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare?.toString() 
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc =  this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc?.toString()
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates =this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates?.toString();
          this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein?.toString()

          this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress = data.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress;
          // if(val =="new") {
          //   this.getClientDetails();
          // }
        }
      },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, "error");
        }
      )
    }

  }

  ////////////////////////////////////// SAVE DOCUMENT //////////////////////////////////////////////////////////////

  SaveDocument() {
this.isSaveorUpdateBoolean=true;
    ///////////////// Change Date Format To Save ////////////////////////////////////////////        
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != null && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != null && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != null && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != null && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != null && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != null && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != null && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != null && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != null && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != null && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods != null) ? parseFloat(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods.toString()) : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing != null) ? parseFloat(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing.toString()) : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget != null) ? parseFloat(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget.toString()) : null;
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare =  (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare == 'true') ? true : (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare == 'false') ? false : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc == 'true') ? true : (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc == 'false') ? false : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates == 'true') ? true : (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates == 'false') ? false : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein == 'true') ? true : (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein == 'false') ? false  : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.signature = this.signature;
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signature = this.Partisign;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2 = this.pantsign;
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.sign = this.pantsign1;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.sign = this.signhere1;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSign = this.signhere2;

    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {

      if (this.ClientAgreementDocumentBO.id == "00000000-0000-0000-0000-000000000000") {
        this.ClientAgreementDocumentBO.id = this.clientonboardBO.documentid
        this.ClientAgreementDocumentBO.clientId = this.clientonboardBO.clientID
        this.ClientAgreementDocumentBO.documentValue = this.ClientAgreementDocumentMergedBO;
        this.clientservice.SaveClientDocumentForAgency(this.ClientAgreementDocumentBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.isSaveorUpdateBoolean=false;
          if (data) {
            this.ClientAgreementDocumentBO.id = data
            this.clientonboardBO.documentid = data;
            // this.GetDocumentData('edit');
            this.toastr.success(' Document Saved SuccessFully');
            this.DataToClientOnBoardList();
          }
        },
          (err: HttpErrorResponse) => {
            this.isSaveorUpdateBoolean=false;
            this.toastrService.error(err.error, "error");
          }
        )
      }
      else {
        this.ClientAgreementDocumentBO.clientId = this.clientonboardBO.clientID
        this.ClientAgreementDocumentBO.documentValue = this.ClientAgreementDocumentMergedBO;       
        this.clientservice.SaveClientDocumentForAgency(this.ClientAgreementDocumentBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.isSaveorUpdateBoolean=false;
          if (data) {
            this.ClientAgreementDocumentBO.id = data;
            this.clientonboardBO.documentid = data;
            // this.GetDocumentData('edit');
            this.toastr.success(' Document Updated SuccessFully ');
            this.DataToClientOnBoardList();
          }
        },
          (err: HttpErrorResponse) => {
            this.isSaveorUpdateBoolean=false;
            this.toastrService.error(err.error, "error");
          }
        )
      }

    }

    else {
      this.ClientAgreementDocumentBO.documentValue = this.ClientAgreementDocumentMergedBO
      this.clientservice.SaveClientDocumentForPortal(this.ClientAgreementDocumentBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.isSaveorUpdateBoolean=false;
        if (data) {
          this.ClientAgreementDocumentBO.id = data
          this.toastr.success(' Document Saved SuccessFully');
          this.DataToClientOnBoardList();
        }
      },
        (err: HttpErrorResponse) => {
          this.isSaveorUpdateBoolean=false;
          this.toastrService.error(err.error, "error");
        })
    }
  }
  ///////////////////////////////////// PHONE FORMAT //////////////////////////////////////////////////

  DemographicPhoneFormat() {
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentDayTimePhone = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentDayTimePhone);
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.dayTimePhone = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.dayTimePhone);

    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate);
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate);
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.designees_telephone_number = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.designees_telephone_number);
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_PhoneNumber);
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.phoneNumber);
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.faxNumber = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.faxNumber);
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signPhoneNumber = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signPhoneNumber);
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_FaxNumber = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.primary_Appointee_FaxNumber);
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.applicants_Telephone_Number = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.applicants_Telephone_Number);
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.designees_Fax_Number = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.designees_Fax_Number);
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.applicants_Fax_Number = this.general.converPhoneGoogleLib(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.applicants_Fax_Number);
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress.forEach(element => {
      element.phoneNumber = this.general.converPhoneGoogleLib(element.phoneNumber)
      element.faxNumber = this.general.converPhoneGoogleLib(element.faxNumber)
    })
  }
  ///////////////////////Add Additional Appointee////////////////////////////////////////

  AppointeeBoolean: boolean = false;
  CreateAdditionalAppointees() {
    if (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress.length > 0) {
      this.AppointeeBoolean = true;
    }
    let list = new Additional_AppointeeAddressDocumentBO();
    this
    .ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress.push(list);
  }
  RemoveAdditionalAppointees(Contact) {
    if (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress.length > 1) {
      this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress.splice(Contact, 1);
    }
  }
  /////////////////////////// SIGNATURE SAVE ////////////////////////////
  here() {
    this.signhere1 = this.signpadone.toDataURL();
  }

  here2() {
    this.signhere2 = this.signpadtwo.toDataURL()
  }

  Clear() {
    this.signpadone.clear();
    this.signhere1 = '';
  }
  Clear2() {
    this.signpadtwo.clear();
    this.signhere2 = '';
  }

  user() {
    this.signature = this.userpad.toDataURL();
  }

  clearuser() {
    this.userpad.clear();
    this.signature = '';
  }

  pant() {
    this.pantsign = this.pantpad.toDataURL();
  }

  clearpant() {
    this.pantpad.clear();
    this.pantsign = '';
  }

  Parti() {
    this.Partisign = this.powerpad.toDataURL();
  }

  clearParti() {
    this.powerpad.clear();
    this.Partisign = '';
  }

  pant1() {
    this.pantsign1 = this.pantpad1.toDataURL();
  }

  clearpant1() {
    this.pantpad1.clear();
    this.pantsign1 = '';
  }

  ////////////////////////////// Key Press Event /////////////////////////////////

  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  NumbersOnly(event: any) {
    const pattern = /^[0-9]*\.?[0-9]*$/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  /////////////////////////////// Clear Document Value ////////////////////////////////////////

  clearparticipantbo() {
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO = new ParticipantAgreementDocumentBO();
    this.clearpant();
  }

  clearreleasebo() {
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO = new Release_of_InformationDocumentBO();
    this.clearpant1();
  }

  clearapplicationbo() {
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO = new Application_Employer_Identification_NumberDocumentBO();
    this.clearuser();
  }

  clearpayerbo() {
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO = new EmployerOrPayerAppointmentOfAgentDocumentBO();
    this.Clear2();
    this.Clear();
  }

  clearindivualbo() {
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO = new Individual_Sole_Proprietor_OfAttornyDocumentBO();
    let goal1 = new Additional_AppointeeAddressDocumentBO();
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.additional_appointeeAddress.push(goal1);
    this.clearParti();
  }

  authchange(event) {
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare = event
  }

  authchange1(event) {
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc = event
  }

  authchange2(event) {
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates = event
  }

  authchange3(event) {   
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = event
  }

  ////////////////////////// Clear Radio Button While Click //////////////////////////////

  radio1() {
    this.ssnbool1 = true
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false

    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny = ''
  }

  radio2() {
    this.ssnbool2 = true
    this.ssnbool1 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny = ''
  }

  radio3() {
    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = true
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false

    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny = ''
  }

  radio4() {

    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = true
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny = ''
  }

  radio5() {
    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = true
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny = ''
  }


  radio6() {
    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = true
    this.ssnbool7 = false
    this.ssnbool8 = false
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny = ''
  }

  radio7() {

    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = true
    this.ssnbool8 = false
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny = ''
  }

  radio8() {
    this.ssnbool1 = false 
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = true
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin = ''    
  }

  event() {
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.solepropritor_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.corporationNumber = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.otherNonProfitOrgText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_9aText = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.estate_Ssn = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.planAdministrator_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.trust_Tin = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.genIfAny = ''
    this.ssnbool1 = false
    this.ssnbool2 = false
    this.ssnbool3 = false
    this.ssnbool4 = false
    this.ssnbool5 = false
    this.ssnbool6 = false
    this.ssnbool7 = false
    this.ssnbool8 = false
  }

  radiochange1(value) {
    if (value.target.checked == true) {
      this.snbool1 = true;
      this.snbool2 = false
      this.snbool3 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_10_specify = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange2(value) {
    if (value.target.checked == true) {
      this.snbool2 = true;
      this.snbool1 = false;
      this.snbool3 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange3(value) {
    if (value.target.checked == true) {
      this.snbool3 = true;
      this.snbool1 = false;
      this.snbool2 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_10_specify = ''      
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange4(value) {
    if (value.target.checked == true) {
      this.snbool4 = true;
      this.snbool2 = false
      this.snbool1 = false
      this.snbool3 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_10_specify = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange5(value) {
    if (value.target.checked == true) {
      this.snbool5 = true;
      this.snbool2 = false
      this.snbool1 = false
      this.snbool3 = false
      this.snbool4 = false
      this.snbool6 = false
      this.snbool7 = false
      this.snbool8 = false
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_10_specify = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType = ''
       this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange6(value) {
    if (value.target.checked == true) {
      this.snbool6 = true;
      this.snbool2 = false
      this.snbool1 = false
      this.snbool3 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool7 = false
      this.snbool8 = false
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_10_specify = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType = ''
    }
  }

  radiochange7(value) {
    if (value.target.checked == true) {
      this.snbool7 = true;
      this.snbool2 = false
      this.snbool1 = false
      this.snbool3 = false
      this.snbool4 = false
      this.snbool5 = false
      this.snbool6 = false
      this.snbool8 = false
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_10_specify = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext = ''
      this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType = ''      
    }
  }

  radioevent() {
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.startedNewbusinessSpecifyType = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.other_10_specify = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.backingPurposeSpecifyType = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.changedTypeOrgType = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.purchaseedGoingBusinesstext = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdTrustSpecifyType = ''
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.createdPensionPlanSpecifyType = ''
    this.snbool1 = false
    this.snbool2 = false
    this.snbool3 = false
    this.snbool4 = false
    this.snbool5 = false
    this.snbool6 = false
    this.snbool7 = false
    this.snbool8 = false
  }

  changeevent() {
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.othertext_16 = ''
    this.otherbool = false
  }

  otherbool: boolean = false;
  otherchange(value) {
    if (value != null || value != undefined || value != '') {
      this.otherbool = true
    }
    else {
      this.otherbool = false
    }

  }

  onClick() {
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods1 = '';
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax1 = '';
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods2 = '';
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax2 = '';
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods3 = '';
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Granted_Type_of_Tax3 = '';
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.years_of_Periods4 = '';
  }


  //////////////////  Validation For Additional Appointee /////////////////////////

  validchange1(index, val) {
    if (val.phoneNumber != '' && val.phoneNumber != null && val.phoneNumber != undefined) {
      if (val.phoneNumber.length != 14) {
        this.errphone1[index] = true
        this.phonerr1[index] = 'Enter Valid phone, Enter 10 digit'
        this.bool2 = true
      }
      else {
        this.errphone1[index] = false
        this.phonerr1[index] = ''
        this.bool2 = false
      }
    }
    else {
      this.errphone1[index] = false
      this.bool2 = false
      this.phonerr1[index] = ''
    }

  }

  validchange2(index, val) {
    if (val.faxNumber != '' && val.faxNumber != null && val.faxNumber != undefined) {
      if (val.faxNumber.length != 14) {
        this.errphone2[index] = true
        this.phonerr2[index] = 'Enter Valid fax, Enter 10 digit'
        this.bool3 = true
      }
      else {
        this.errphone2[index] = false
        this.phonerr2[index] = ''
        this.bool3 = false
      }
    }
    else {
      this.errphone2[index] = false
      this.bool3 = false
      this.phonerr2[index] = ''
    }
  }

  validchange3(index, val) {
    if (val.zip != '' && val.zip != null && val.zip != undefined) {
      if (val.zip.length <= 4) {
        this.errZip[index] = true
        this.ziperr[index] = 'Enter Valid zip, Enter  5 to 11 digits'
        this.bool4 = true
      }
      else {
        this.errZip[index] = false
        this.ziperr[index] = ''
        this.bool4 = false
      }
    }
    else {
      this.errZip[index] = false
      this.bool4 = false
      this.ziperr[index] = ''

    }

  }


  ////////////////////////////// 'SENT TO CLIENT' && 'SUBMIT' && 'COMPLETE'  DOCUMENT ////////////////////////////
  CompleteBo: CompleteBo = new CompleteBo()
  SendAcceptNotes: string;
  CommonSave() {
    ////////////////// CHANGE DATE FORMAT FOR  SENT TO CLIENT  && SUBMIT && Complete  ///////////////////////////////////
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != null && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != null && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != null && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != null && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != null && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != null && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != null && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != null && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != null && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != null && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != undefined) ? (new Date(new Date(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", "") : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods != null) ? parseFloat(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithGoods.toString()) : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing != null) ? parseFloat(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.cdcsBudgetwithStaffing.toString()) : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget != null) ? parseFloat(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.csgBudget.toString()) : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.signature = this.signature;
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signature = this.Partisign;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2 = this.pantsign;
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.sign = this.pantsign1;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.sign = this.signhere1;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSign = this.signhere2;
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare =  (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare == 'true') ? true : (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.authorizeBestCare == 'false') ? false : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc == 'true') ? true : (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicationLlc == 'false') ? false : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates == 'true') ? true : (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isllc_Organized_UnitedStates == 'false') ? false : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein == 'true') ? true : (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.isapplicant_entity_shown_line1_everapplied_for_and_received_an_Ein == 'false') ? false  : null;
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD') {

      ////////////////////// COMPLETE  ///////////////////////////////
      if (this.clientonboardBO?.statusinfo == 'Submitted') {
        this.CompleteBo.id = this.clientonboardBO.documentid;
        this.CompleteBo.clientId = this.clientonboardBO.clientID;
        this.CompleteBo.documentValue = this.ClientAgreementDocumentMergedBO;
        this.clientservice.COMPLETE(this.CompleteBo).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          this.toastrService.success("Application Completed SuccessFully")
          document.getElementById('Opencompletemodal').click();
          this.DataToClientOnBoardList();
        },
          (err: HttpErrorResponse) => {
            this.toastrService.error(
              "error",
            );
          })
      }
      else {
        //////////////////////////////// SENT TO CLIENT /////////////////////////
        this.sendToClientBO.clientId = this.clientonboardBO.clientID;
        this.sendToClientBO.agencyNote = this.SendToClientNotes;
        this.sendToClientBO.documentLid = this.clientonboardBO.documentid;
        this.sendToClientBO.portalLink= this.configurationservice.environment.onboardingUrl +'#/onboarding/client/'
        this.sendToClientBO.documentValue = this.ClientAgreementDocumentMergedBO;
        this.clientservice.SendToClient(this.sendToClientBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          if (data) {
            this.toastrService.success("Application Sent Successfully")
            document.getElementById("send_to_client").click()
            this.DataToClientOnBoardList();
          }
        },
          (err: HttpErrorResponse) => {
            this.toastrService.error(err.error);
          }
        )

      }

    }
    //////////////////////////////// SUBMIT  /////////////////////////
    else {
      this.ClientAgreementDocumentBO.clientId = this.clientonboardBO.clientID
      this.ClientAgreementDocumentBO.id = this.clientonboardBO.documentid
      this.ClientAgreementDocumentBO.documentValue = this.ClientAgreementDocumentMergedBO
      this.clientservice.savesubmit(this.ClientAgreementDocumentBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data) {
          this.ClientAgreementDocumentBO.id = data
          this.toastr.success('Application Submitted Successfully ');
          this.DataToClientOnBoardList();
        }
      },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, "error");
        })

    }
  }

  clearSendFields() {
    this.SendToClientNotes = '';
  }
  clearCompleteFields() {
    this.SendAcceptNotes = '';
  }

  ngAfterContentChecked() {
    this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != null && this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate != undefined) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.release_of_InformationDocumentBO.signDate, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.effectivedate, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date = (this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != '' && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != undefined && this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.participantAgreementDocumentBO.participantSign2Date, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != undefined && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.authority_Experiation_Date, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate = (this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != '' && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != undefined && this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.individual_Sole_Proprietor_OfAttornyDocumentBO.signatureDate, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.dateofBusinessStarted, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.first_date_wages_Annuities_were_paid, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != undefined && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.agentSignDate, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate = (this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != '' && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != undefined && this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.employerOrPayerAppointmentOfAgentDocumentBO.signDate, "MM/dd/yyyy") : null;
    this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date = (this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != '' && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != undefined && this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date != null) ? this.datepipe.transform(this.ClientAgreementDocumentMergedBO.application_Employer_Identification_NumberDocumentBO.date, "MM/dd/yyyy") : null;

  }

  submitClientAggrementDetails() {
  console.log("this.clientonboardBO",this.clientonboardBO);
    let submitAggremntNo:SubmitClientAggremntBo = new SubmitClientAggremntBo();
   submitAggremntNo.aggrementId=this.clientonboardBO.documentid;
  
   
    this.clientservice
        .submitClientDocPortal(submitAggremntNo)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data) => {
            this.clientonboardBO.statusinfo='Submitted';
            this.EmployerIdentificationForm.disable();
            this.EmployerORPayerForm.disable();
            this.IndivualForm.disable();
            this.toastrService.success("Participant Agreement Submitted Successfully");
           // this.getAgreementDetails();
           
          },
          (err: HttpErrorResponse) => {
            this.toastrService.error(err.error, "error");
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
          }
        );
  }

  DataToClientOnBoardList() {
    this.saveAllEvent.emit(true);
  }

}